// Generated by purs version 0.13.0
"use strict";
var $foreign = require("./foreign.js");
var Quiet = (function () {
    function Quiet() {

    };
    Quiet.value = new Quiet();
    return Quiet;
})();
var Sound = (function () {
    function Sound(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    Sound.create = function (value0) {
        return function (value1) {
            return new Sound(value0, value1);
        };
    };
    return Sound;
})();
var ExclusiveSound = (function () {
    function ExclusiveSound(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    ExclusiveSound.create = function (value0) {
        return function (value1) {
            return new ExclusiveSound(value0, value1);
        };
    };
    return ExclusiveSound;
})();
var RepeatSound = (function () {
    function RepeatSound(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    RepeatSound.create = function (value0) {
        return function (value1) {
            return new RepeatSound(value0, value1);
        };
    };
    return RepeatSound;
})();
var effectType = function (v) {
    if (v instanceof Quiet) {
        return "quiet";
    };
    if (v instanceof Sound) {
        return "sound";
    };
    if (v instanceof ExclusiveSound) {
        return "exclusiveSound";
    };
    if (v instanceof RepeatSound) {
        return "repeatSound";
    };
    throw new Error("Failed pattern match at Chip.Lib.Sound (line 36, column 1 - line 36, column 36): " + [ v.constructor.name ]);
};
var play = $foreign["play'"](effectType);
module.exports = {
    Quiet: Quiet,
    Sound: Sound,
    ExclusiveSound: ExclusiveSound,
    RepeatSound: RepeatSound,
    play: play
};
